<ng-container *ngIf="viewModel$ | async as vm">

  <section *ngIf="vm.weatherModules.length + vm.energyModules.length > 1">

    <app-dropdown class="is-fullwidth small" [formControl]="formControl">
      <app-dropdown-value class="is-fullwidth"></app-dropdown-value>

      <ng-container *ngFor="let module of vm.energyModules">
        <app-dropdown-item [value]="module.value" [label]="module.label"></app-dropdown-item>
      </ng-container>

      <ng-container *ngFor="let module of vm.weatherModules">
        <app-dropdown-item [value]="module.value" [label]="module.label"></app-dropdown-item>
      </ng-container>

    </app-dropdown>

  </section>

</ng-container>
